import { createReducer } from '@topconagriculture/frontend-utils';
import { closeAllModals, openModal, setModalTitle } from './modal.actions';
export const initialState = {
    isVisible: false,
    modalRequested: null,
    modalParams: null,
    modalOptions: {
        dialogProps: null,
        closeButtonIsVisible: true,
        modalTitle: null,
    },
};
const modalReducer = createReducer(initialState, {
    [openModal.type]: (state, action) => {
        if (typeof action.payload === 'object') {
            return {
                ...state,
                isVisible: true,
                modalRequested: action.payload.modalName,
                modalParams: action.payload.modalParams,
                modalOptions: {
                    modalTitle: action.payload.modalOptions && action.payload.modalOptions.modalTitle
                        ? action.payload.modalOptions.modalTitle
                        : null,
                    dialogProps: action.payload.modalOptions && action.payload.modalOptions.modalDialogProps
                        ? action.payload.modalOptions.modalDialogProps
                        : state.modalOptions.dialogProps,
                    closeButtonIsVisible: action.payload.modalOptions &&
                        action.payload.modalOptions.hasOwnProperty('closeButtonIsVisible')
                        ? action.payload.modalOptions.closeButtonIsVisible
                        : state.modalOptions.closeButtonIsVisible,
                },
            };
        }
        else {
            return {
                ...state,
                isVisible: true,
                modalRequested: action.payload,
                modalOptions: {
                    modalTitle: null,
                    dialogProps: state.modalOptions.dialogProps,
                    closeButtonIsVisible: state.modalOptions.closeButtonIsVisible,
                },
            };
        }
    },
    [setModalTitle.type]: (state, action) => {
        return {
            ...state,
            modalOptions: {
                ...state.modalOptions,
                modalTitle: action.payload,
            },
        };
    },
    [closeAllModals.type]: (state) => {
        return {
            ...state,
            isVisible: false,
            modalRequested: null,
            modalParams: null,
            modalOptions: {
                dialogProps: null,
                closeButtonIsVisible: true,
                modalTitle: null,
            },
        };
    },
});
export default { modal: modalReducer };
//# sourceMappingURL=modal.reducer.js.map